// removed by extract-text-webpack-plugin
module.exports = {"container":"UEG5lkc","container__extraPadding":"_7o2iemF","hitArea":"_3l4GUXL","chevronRight":"_2aCAEI1","chevronLeft":"_22cDiP5"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/SideNavigationContainer/CarouselContainer/index.css
// module id = ./template/components/Navigation/SideNavigationContainer/CarouselContainer/index.css
// module chunks = client.sitechrome